/*interface ICarSimProps
{
    EmployerRejectedSpending: number;
    ListMonthlyBenefits : Array<number>;
    ListMonthlyProfDeduction : Array<number>;
    ListCo2Contribution : Array<number>;

    YearlyBenefits : number;
    YearlyProfDeduction : number;
    YearlyCo2Contribution : number;

    // second part --> data will only be displayed if income year is >= 2018 
    ListMonthlyMobilityAllowance : Array<number>;
    ListMonthlyTaxableBenefits : Array<number>;
    ListMonthlyProfDeductionEstimate : Array<number>;
    ListMonthlyCo2ContributionAllowance : Array<number>;

    YearlyMobilityAllowance : number;
    YearlyTaxableBenefits : number;
    YearlyProfDeductionEstimate : number;
    YearlyCo2ContributionAllowance : number;
}
*/
export default class CarSimProps// implements ICarSimProps
{
    constructor()
    {
        // this.employerRejectedSpending = 0;
        this.listMonthlyBenefits = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        this.listMonthlyProfDeduction = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        this.listCo2Contribution = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        this.yearlyBenefits = 0;
        this.yearlyProfDeduction = 0;
        this.yearlyCo2Contribution = 0;
        // this.listMonthlyMobilityAllowance = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        // this.listMonthlyTaxableBenefits = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        // this.listMonthlyProfDeductionEstimate = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        // this.listMonthlyCo2ContributionAllowance = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        // this.yearlyMobilityAllowance = 0;
        // this.yearlyTaxableBenefits = 0;
        // this.yearlyProfDeductionEstimate = 0;
        // this.yearlyCo2ContributionAllowance = 0;
    }

    // employerRejectedSpending: number;
    listMonthlyBenefits: number[];
    listMonthlyProfDeduction: number[];
    listCo2Contribution: number[];
    yearlyBenefits: number;
    yearlyProfDeduction: number;
    yearlyCo2Contribution: number;
    // listMonthlyMobilityAllowance: number[];
    // listMonthlyTaxableBenefits: number[];
    // listMonthlyProfDeductionEstimate: number[];
    // listMonthlyCo2ContributionAllowance: number[];
    // yearlyMobilityAllowance: number;
    // yearlyTaxableBenefits: number;
    // yearlyProfDeductionEstimate: number;
    // yearlyCo2ContributionAllowance: number;
}